<template>
  <div v-if="load" class="mb60">
    <Title :prev="'designer-generations'"
           :title="title"
           :secondTitle="'Выберите вопросы для карты'"
    />
    <div class="row justify-content-center">
      <div class="col-xl-10">
        <div class="edit edit--no-height bg-gray">
          <h3 class="questions__title">
            Выберите вопросы для определения кресел автомобиля
          </h3>
          <draggable v-model="data"
                     class="questions"
                     @end="endDrag"
                     @start="drag = true"
                     v-bind="dragOptions"
          >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div class="questions__item questions__item-checkbox options-parent list-group-item pr150"
                   v-for="item in data"
                   :key="item.name"
              >
                <div class="questions__item-dots">
                  <span v-for="index in 4"></span>
                </div>
                <InputCheckbox :label="item.name"
                               :name="item.name"
                               v-model="value[item.name]"
                               @input="change($event, item)"
                />
                <span v-if="item.status === 'inactive'" class="disable">Отключён</span>
                <Options :namePage="'designer-generations-questions'"
                         :id="item._id"
                         class="options-wrap-questions"
                         :parentMouse="options"
                         :status="value[item.name]"
                />
              </div>
            </transition-group>
          </draggable>
          <div class="d-flex justify-content-end mt10">
            <router-link :to="{name: 'designer-generations-questions-new'}" class="btn btn--blue btn--small">Добавить вопрос</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>
  import Title from "../components/Title";
  import Options from "../components/Options";
  import Loader from "../components/Loader";
  import InputCheckbox from "../components/inputs/InputCheckbox";
  import Tabs from "../components/Tabs";
  import draggable from 'vuedraggable'

  export default {
    name: "QuestionsGenerations",
    components: {Tabs, InputCheckbox, Loader, Options, Title, draggable},
    data() {
      return {
        load: false,
        data: [],
        title: decodeURI(this.$route.params['brand']),
        value: {},
        options: true,
        drag: false
      }
    },
    methods: {
      change(e, data) {
        let params = {};
        this.value[data.name] = e;
        Object.assign(params, this.$route.params);
        params.status = this.value[data.name];
        params.name = data.name;
        params._id = data._id;
        this.$store.dispatch('questionsGenerations/QUESTION_GENERATIONS_EDIT', params)
          .then(res => {
            if (res.ok) {
              this.getData();
            }
          });
      },
      getData() {
        this.load = false;
        console.log(this.$route.params)
        this.$store.dispatch('questionsGenerations/QUESTIONS_GENERATIONS', this.$route.params)
          .then(res => {
            for (let key in res.body) {
              this.$set(this.value, res.body[key].name, res.body[key].status);
            }
            let valueCopy = [];
            for (let key in this.value) {
              valueCopy.push(key);
            }
            this.data = res.body;
            this.getTitle();
          })
      },
      getTitle() {
        let params = {};
        Object.assign(params, this.$route.params);
        params.id = params.m_id;
        this.$store.dispatch('models/MODEL', params)
          .then(res => {
            this.title += ` ${res.body.name} `;
            params.id = params.g_id;
            this.$store.dispatch('generations/GENERATION', params)
              .then(res => {
                this.title += res.body.name;
                this.load = true;
              })
          })
      },
      endDrag(e) {
        this.drag = false;
        let params = {};
        Object.assign(params, this.$route.params);
        params.number = e.newIndex;
        params.q_id = this.data[e.newIndex]._id;
        this.$store.dispatch('questionsGenerations/QUESTION_GENERATIONS_ORDER', params);
      }
    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.getData();
      });
    },
    metaInfo() {
      return {
        title: this.title
      }
    }
  }
</script>

<style lang="scss">
  .list-group-item {
    cursor: move;
    span {
      cursor: move;
    }
  }
  .ghost {
    opacity: 0.5;
  }
</style>